var enums = Object.create(null);

enums.ACTIVITY_TYPE = {
  PADEL: 'PADEL',
  BADMINTON: 'BADMINTON',
  SQUASH: 'SQUASH',
  FUTSAL: 'FUTSAL',
  CANOE: 'CANOE',
  VTT: 'VTT',
  QUIZZROOM: 'QUIZZROOM',
  GROUP_ACTIVITY: 'GROUP_ACTIVITY'
};

enums.ACCESS_CONTROL_PROVIDER = {
  TTLOCK: 'TTLOCK',
  IPEVIA: 'IPEVIA'
};

enums.TYPE_DURATION = {
  MONTH: 'month',
  WEEK: 'week',
  DAY: 'day',
  YEAR: 'year'
};

module.exports = enums;
